
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject
} from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BaseService } from 'app/profile/services/base.service';
import { HttpClient } from '@angular/common/http';



@Injectable()
export class GridService extends BaseService {
    options: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(private http: HttpClient) {
        super()
     }

    get(path: string): Observable<any> {
        return this.http.get<any>(path, { headers: this.setHeaders() });
    }

    getOptions() {
        return this.options.asObservable();
    }

    setOptions(options) {
        this.options.next(options);
    }
}
